import RemindersSummaryContainer from './reminders-summary-container';

export default RemindersSummaryContainer;
